import * as React from "react";
import { gql, useQuery } from "@apollo/client";
import {
  Wallet,
  WalletQueryQuery
} from "../../schemaTypes";

export const walletQuery = gql`
  query WalletQuery {
    wallet {
      id
      flId
      currency
      barterId
      balance
      owner {
        id
      }
      flNuban
      bankName
      bankCode
      flAccountReference
      flNuban
      status
      createdAt
      updatedAt
    }
  }
`;

export const walletUpdateSubscription = gql`
  subscription WalletUpdateSubscription {
    walletUpdate {
      id
      flId
      currency
      barterId
      balance
      owner {
        id
      }
      flNuban
      bankName
      bankCode
      flAccountReference
      flNuban
      status
      createdAt
      updatedAt
    }
  }
`;

export interface WithWallet {
  match: WalletQueryQuery['wallet'] | null;
  loading: boolean;
}

interface Props {
  children: (data: WithWallet) => React.ReactElement | null;
}

export const ViewWallet: React.FC<Props> = ({ children }) => {
  const { data, loading, subscribeToMore } = useQuery<WalletQueryQuery>(walletQuery);

  React.useEffect(() => {
    if (!subscribeToMore) return;
    const unsubscribe = subscribeToMore({
      document: walletUpdateSubscription,
      updateQuery: (prev, { subscriptionData }: { subscriptionData: { data?: { walletUpdate: Wallet } } }) => {
        if (!subscriptionData.data) return prev;
        return {
          ...prev,
          wallet: subscriptionData.data.walletUpdate
        };
      }
    });
    return () => unsubscribe();
  }, [subscribeToMore]);

  let match: WalletQueryQuery['wallet'] | null = null;
  if (data && data.wallet) {
    match = data.wallet;
  }

  return children({
    match,
    loading
  });
};